import { render, staticRenderFns } from "./wechatLoginCodeEdit.vue?vue&type=template&id=ab272dc4&scoped=true"
import script from "./wechatLoginCodeEdit.vue?vue&type=script&lang=js"
export * from "./wechatLoginCodeEdit.vue?vue&type=script&lang=js"
import style0 from "./wechatLoginCodeEdit.vue?vue&type=style&index=0&id=ab272dc4&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab272dc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab272dc4')) {
      api.createRecord('ab272dc4', component.options)
    } else {
      api.reload('ab272dc4', component.options)
    }
    module.hot.accept("./wechatLoginCodeEdit.vue?vue&type=template&id=ab272dc4&scoped=true", function () {
      api.rerender('ab272dc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/temporaryLogin/wechatLoginCode/wechatLoginCodeEdit.vue"
export default component.exports